import React from 'react'
import { MainScreen } from './screens'

import './app.module.css'

function App() {
  return (
    <>
      <MainScreen />
    </>
  )
}

export default App
